import { FC } from "react";
import { TextBoxVersionEnum } from "../../../models";
import { CommonTextBoxProps } from "./commonTextBoxProps";
import {TextBoxV1} from "./textBoxV1";
import {TextBoxV2} from "./textBoxV2";
import {generateGuid} from "../../../utils";


type TextBoxProps = CommonTextBoxProps & {
    optimizeTyping?: boolean;
    resetKey?: string;
    version?: TextBoxVersionEnum;
};


export const TextBox: FC<TextBoxProps> = ({
                                              // Common props with default values
                                              labelName,
                                              inputName,
                                              inputValue,
                                              errorText,
                                              placeHolder,
                                              isMandatory = false,
                                              isReadOnly = false,
                                              isVisible = true,
                                              type = "text",
                                              onChange,
                                              onBlur,
                                              onKeyPress,
                                              controlSize = "col flex-form-control",
                                              labelSize = "form-label",
                                              inputRef,
                                              formatType = "none",
                                              preventNegative = false,
                                              inputContainerClassName,
                                              row=3,
                                              style,className,
                                                // V2-specific props
                                              optimizeTyping,
                                              resetKey,
                                              // Version with default
                                              version = TextBoxVersionEnum.V2
                                          }) => {
    const commonProps = {
        labelName,
        inputName,
        inputValue,
        errorText,
        placeHolder,
        isMandatory,
        isReadOnly,
        isVisible,
        type,
        onChange,
        onBlur,
        onKeyPress,
        controlSize,
        labelSize,
        inputRef,
        formatType,
        preventNegative,
        inputContainerClassName,
        row,style,className
    };

    const v2Props = {
        ...commonProps,
        optimizeTyping:true,
        resetKey:resetKey??generateGuid(),
    };

    return version === TextBoxVersionEnum.V1  ? <TextBoxV1 {...commonProps} />: <TextBoxV2 {...v2Props} />;
};
